<template>
    <HeaderComp/>
        <div class="bg-fourth">
            <div class="container">
                <router-view></router-view>
            </div>
        </div>
    <FooterComp/>
</template>

<script>
import HeaderComp from '../../components/Auth/Header.vue'
import FooterComp from '../../components/Auth/Footer.vue'
export default {
    name: 'AMTAuth',
    components: {
        HeaderComp,
        FooterComp
    }
}
</script>

<style lang="scss" scoped>
</style>